import * as api from '@yandex-int/k-common/client/api';
import { Theme } from '@yandex-int/k-common/typings';
// @ts-ignore
import { showNetworkError } from 'platform-components/src/components/notification/actions';
import { SUBJECTS_SLUGS_TYPE } from 'platform-components/src/typings';
import { reportMessage } from 'platform-components/utils';
import { call, put, takeLatest, all, select } from 'redux-saga/effects';

import * as actions from './actions';
import * as constants from './constants';
import * as selectors from './selectors';

const MAX_THEMES_TREE_DEPTH = 2;

export function* themesSagasWatcher() {
    yield all([
        takeLatest(constants.GET_ROOT_THEMES_REQUEST, getRootThemesSaga),
        takeLatest(constants.GET_THEMES_TREE_REQUEST, getThemesTreeRequestSaga),
        takeLatest(constants.GET_ACTUAL_THEMES_REQUEST, getActualThemesRequestSaga),
    ]);
}

function* getRootThemesSaga(action: ReturnType<typeof actions.getRootThemesRequest>) {
    const { subject } = action;

    try {
        const themes: Theme[] = yield call(api.getThemesFlat, { subjectSlug: subject, depth: 0 });
        yield put(actions.getRootThemesSuccess(subject, themes));
    } catch (error) {
        console.error(error);

        yield put(actions.getRootThemesError(subject));
        yield put(showNetworkError(error));
    }
}

function* getThemesTreeRequestSaga(action: ReturnType<typeof actions.getThemesTreeRequest>) {
    const { subject, themeId, depth } = action;

    try {
        const themes: Array<Theme> = yield call(getFlatFullTreeUtil, themeId, subject, depth);

        const rootTheme = themes.find((theme) => !theme.parent);

        if (rootTheme) {
            yield put(actions.getThemesTreeSuccess(subject, themeId, themes, rootTheme.id));
        }
    } catch (error) {
        const isActualTheme: boolean = yield select(selectors.getIsActualTheme, { themeId });
        // отсутствие темы валидная ситуация, не нужно пугать пользователя ошибкой
        // и не пугаем при проблемах с актуальными темами
        if (error.status !== 404 && !isActualTheme) {
            console.error(error);

            yield put(showNetworkError(error));
        }

        yield put(actions.getThemesTreeError(subject, themeId));
    }
}

function* getFlatFullTreeUtil(themeId: number, subject: SUBJECTS_SLUGS_TYPE, depth: number = MAX_THEMES_TREE_DEPTH) {
    const PAGE_SIZE = 500;

    let hasNextPage: boolean = true;
    let themes: Array<Theme> = [];
    let currentPage = 1;

    while (hasNextPage) {
        const currentChunk: Array<Theme> = yield call(api.getThemesFlatFullTree, themeId, {
            page: currentPage,
            pageSize: PAGE_SIZE,
            depth,
            subject,
        });

        themes = themes.concat(currentChunk);
        hasNextPage = currentChunk.length === PAGE_SIZE;

        currentPage += 1;
    }

    return themes;
}

function* getActualThemesRequestSaga(action: ReturnType<typeof actions.getActualThemesRequest>) {
    const { subject, courseId, grade, umk } = action;
    try {
        const themes: Array<Theme> = yield call(api.getActualThemes, { subject, courseId, grade, umk });

        yield put(actions.getActualThemesSuccess(subject, themes, courseId));
    } catch (error) {
        console.error(error);
        // не показываем красную плашку, а шлем сразу в сентри
        reportMessage(
            `Не удалось получить актуальные темы по курсу ${courseId}, предмету ${subject}, грейду ${grade}, УМК ${umk}.
            Код ошибки ${error?.status}, сообщение ${error?.data?.error?.description}`
        );
        yield put(actions.getActualThemesError(subject, courseId));
    }
}
